import React from 'react';
import ReactDOM from 'react-dom';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';

import './index.css';
import App from './components/App';

const theme = createTheme({
    palette: {
        type: 'dark',
        background: {
            default: "#000000"
        },
        primary: {
            main: "#E3E3E3"
        },
        secondary: {
            main: "#21ca36"
        }
    },
});

ReactDOM.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
);
